import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_CLIENTS: string = typeCreatorV2(
  'ClientListReducer',
  'SetClients'
);

export const SET_AGENTS: string = typeCreatorV2(
  'ClientListReducer',
  'SetAgents'
);

export const DELETE_CUSTOMER: string = typeCreatorV2(
  'ClientListReducer',
  'DeleteCustomer'
);

export const FETCH_ROLES: string = typeCreatorV2(
  'ClientListReducer',
  'FetchRoles'
);

export const ADD_CUSTOMER: string = typeCreatorV2(
  'ClientListReducer',
  'AddCustomer'
);

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'ClientListReducer',
  'SetClientsMiniProfiles'
);

export const SEND_PASSWORD: string = typeCreatorV2(
  'ClientListReducer',
  'SendPassword'
);

export const SET_VALUE_SEARCH: string = typeCreatorV2(
  'ClientListReducer',
  'SetValueSearch'
);

export const SET_CLIENT_ATTRIBUTE_FOUND_US_ON: string = typeCreatorV2(
  'ClientListReducer',
  'SetClientAttributeFoundUsOn'
);

export const SET_CLIENT_ATTRIBUTE_COMPANY_NAME: string = typeCreatorV2(
  'ClientListReducer',
  'SetClientAttributeCompanyName'
);

export const SET_CITY: string = typeCreatorV2('ClientListReducer', 'SetCity');

export const SET_MUNICIPALITY: string = typeCreatorV2(
  'ClientListReducer',
  'SetMunicipality'
);
